export default {
  // default
  Standard: '',

  // metric
  Metric: 'metric',

  // imperial
  Imperial: 'imperial',
};
